import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { ResumeLinkComponent } from './resume-link.component';

@NgModule({
  declarations: [ResumeLinkComponent],
  imports: [CommonModule, StoreModule],
  exports: [ResumeLinkComponent],
})
export class ResumeLinkModule {}
